module.exports = __webpack_public_path__ + "media/images/icons/icon_pageType_03-c56c95dac9b5f92223e9d0d4d3939fd9.svg";